import React, { useEffect, useRef, useState } from "react";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import TextArea from "../ReusableComponents/TextArea";
import { mainTable } from "../css/Common";
import AddScreenTitle from "../components/AddScreenTitle";
import MultiSelect from "../ReusableComponents/MultiSelect";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import { RoomTypeHeader } from "../components/HeaderAttribute";
import Buttons from "../components/Buttons";
import RoomTypeMasterPopup from "../popup-containers/RoomTypeMasterPopup";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import ErrorPopup from '../ReusableComponents/ErrorPopup';
import {
  BindAPI,
  BindPostAPI,
  ImageAPI,
  IUDAPI,
} from "../services/APIConnection";
import toast from "react-hot-toast";
import Loader from "../ReusableComponents/Loader";
import Image1 from "../image/Image1.jpeg";
import Excutive from "../image/Excutive.jpg";
import Double from "../image/Double.jpg";
import deluxe from "../image//deluxe.jpg";
import Single from "../image/Single.jpg";
import Image2 from "../image/Image2.jpeg";
import FileUpload from "../ReusableComponents/FileUpload";
const RoomType = () => {
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);

  const createdBy = sessionStorage.getItem("createdBy");
  const clientId = sessionStorage.getItem("MstClientId");
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [popUpOpen, setpopUpOpen] = useState(false);
  const [popupData, setPopupData] = useState({});
  const [popupDataDD, setPopupDataDD] = useState({});
  const [roomtTypeDD, setroomTypeDD] = useState([]);

  const [formFields, setFormFields] = useState({
    mstRoomtypeId: "",
    roomType: "",
    noofroom: "",
    size: "",
    maximumOccpancy: "",
    photo: "",
    description: "",
  });

  const [formFieldsError, setFormFieldsError] = useState({
    roomTypeError: "",
    noofroomError: "",
    sizeError: "",
    maximumOccpancyError: "",
    photoError: "",
  });
  const [mstRoomtypeId, setMstRoomtypeId] = useState("");

  const handleShowImage = (showImage) => {
    console.log("image", showImage);

    // Set showImage to an empty string if showImage is falsy
    setFormFields({
      ...formFields,
      photo: showImage || "", // This will set to showImage if it's truthy, else ""
    });

    // console.log(supplierFields);

    // Reset any error related to showImage
    setFormFieldsError({ ...formFieldsError, photoError: "" });
  };
  const API_BASE_URL = window.location.protocol === "https:" ? "https" : "http";
  const [imageDisabled, setImageDisabled] = useState(false);
  const [fileDisabled, setFileDisabled] = useState(false);
  const [selectedFile, setselectedFile] = useState([]);
  const [showImage, setShowImage] = useState("");
  const [showImageError, setShowImageError] = useState("");
  const [roomtypeData, setRoomTypeData] = useState({});
  const fileInputRef = useRef(null);
  const MAX_FILE_SIZE_MB = 2;
  const ALLOWED_FORMATS = ["image/jpeg", "image/jpg", "image/png"];

  const isFileFormatAllowed = (file) => ALLOWED_FORMATS.includes(file.type);

  const isFileSizeBelowLimit = (file) =>
    file.size <= MAX_FILE_SIZE_MB * 1024 * 1024;

  const handleFileChange = (event) => {
    setImageDisabled(false);
    setFileDisabled(true);

    const file = event.target.files[0];
    if (!file) return;

    if (!isFileFormatAllowed(file)) {
      toast.error(`Unsupported file format: ${file.name}`);
      return;
    }

    if (!isFileSizeBelowLimit(file)) {
      toast.error(`File size exceeds the limit`);
      return;
    }

    if (
      selectedFile.length > 0 &&
      selectedFile[0].file.name === file.name &&
      selectedFile[0].file.size === file.size
    ) {
      toast.error("This file is already selected");
      return;
    }

    setselectedFile([
      {
        file,
        previewUrl: URL.createObjectURL(file),
      },
    ]);
  };

  const handleImageCancel = (index) => {
    setImageDisabled(true);
    setFileDisabled(false);
    const updatedTableData = [...selectedFile];
    updatedTableData.splice(index, 1);
    setselectedFile(updatedTableData);
    const formData = new FormData();
    const imageUrlArray = [];

    for (let i = 0; i < updatedTableData.length; i++) {
      imageUrlArray.push(updatedTableData[i].previewUrl);
    }
    const imageUrlString = imageUrlArray.join(",");

    setShowImage(imageUrlString);
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clears the file input value
    }
  };

  useEffect(() => {
    BindRoomType();
  }, []);

  const BindRoomType = async () => {
    try {
      setIsLoading(true);
      const data = {
        mstClientId: clientId,
      };
      const response = await BindPostAPI(data, "RoomTypeAPI/BindRoomType");
      setBindRoomTypeData(response.data?.Table || []);
    } catch (error) {
      console.error("BindRoomType Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const [bindRoomTypeData, setBindRoomTypeData] = useState([]);

  const handleEdit = (rowIndex) => {
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setMstRoomtypeId(bindRoomTypeData[rowIndex].MstRoomTypeId);
    setFormFields({
      ...formFields,
      mstRoomtypeId: bindRoomTypeData[rowIndex].MstRoomTypeId,
      roomType: bindRoomTypeData[rowIndex].RoomType,
      noofroom: bindRoomTypeData[rowIndex].NoOfRooms,
      size: bindRoomTypeData[rowIndex].Size,
      photo: bindRoomTypeData[rowIndex].Photo,
      maximumOccpancy: bindRoomTypeData[rowIndex].MaxOccupancy,
      description: bindRoomTypeData[rowIndex].Description,
    });
  };

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(false);
    setAddScreenTitle(true);
  };
  const handleRoom = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }
    setRoomTypeData(bindRoomTypeData[rowIndex]);
    setFormFields({
      ...formFields,
      mstRoomtypeId: bindRoomTypeData[rowIndex].MstRoomTypeId,
    });
    setPopupData(bindRoomTypeData[rowIndex]);
  };

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  const handleFieldsChange = (value, name) => {
    setFormFields({
      ...formFields,
      [name]: value,
    });
  };

  // example, get from auth or props

  const cancel = () => {
    BindRoomType();
    setVisibleAdd(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setIsLoading(false);
    setpopUpOpen(false);
    setFormFields({
      mstRoomtypeId: "",
      roomType: "",
      size: "",
      noofroom: "",
      maximumOccpancy: "",
      photo: "",
      description: "",
    });

    setFormFieldsError({});
    setShowImage("");
    setselectedFile([]);
    setShowImageError("");
    setIsLoading(false);
    setSubmitBtnDisabled(false);
    setIsOpen(false);

    console.log("Form cancelled and reset");
  };

  const handleSubmit = async (items, flag) => {
    
    if (flag === 1 || flag === 2) {
      setIsLoading(true);
      setSubmitBtnDisabled(true);

      const errors = {
        roomTypeError: formFields.roomType ? "" : "Select Room type",
        sizeError: formFields.size ? "" : "Enter size",
        noofroomError: formFields.noofroom ? "" : "Enter No Of Room",
        maximumOccpancyError: formFields.maximumOccpancy
          ? ""
          : "Enter no. of maximum occupancy",
        photoError: formFields.photo ? "" : "Select files to upload",
      };

      setFormFieldsError(errors);

      const value = formFields.roomType?.trim() || "";
      if (
        bindRoomTypeData.some(
          (item) =>
            item.RoomType?.trim().toLowerCase() === value.toLowerCase() &&
            item.MstRoomTypeId !== formFields.mstRoomtypeId
        )
      ) {
        errors.roomTypeError = "Room Type already exists.";
      }
  
      setFormFieldsError(errors);

      const isFormValid = Object.values(errors).every((err) => err === "");

      // Image Validation

      // Proceed only if all validations pass
      if (isFormValid) {
        const payload = {
          mstClientId: clientId,
          mstRoomtypeId: formFields.mstRoomtypeId || 0,
          roomType: formFields.roomType,
          size: parseInt(formFields.size),
          noofrooms: parseInt(formFields.noofroom),
          maxOccupancy: parseInt(formFields.maximumOccpancy),
          photo: formFields.photo, // Use actual image string
          description: formFields.description,
          createdBy: parseInt(createdBy),
          flag: flag,
        };

        const response = await IUDAPI(payload, "RoomTypeAPI/IUDRoomType");

        const result = response?.data?.Table?.[0]?.Result;

        if (flag === 1 && result === "S") {
          toast.success("Room Type Added Successfully 👍");
          setTimeout(cancel, 3000);
        } else if (flag === 2 && result === "M") {
          toast.success("Room Type Updated Successfully 👍");
          setTimeout(cancel, 3000);
        } else {
          toast.error("Failed to save Room Type 👎");
          setTimeout(cancel, 3000);
        }
      } else {
        setIsLoading(false);
        setSubmitBtnDisabled(false);
        setIsOpen(true);
      }
    } else {
      // Handle delete / activate / inactivate
      const data = {
        mstRoomtypeId: formFields.mstRoomtypeId,
        createdby: parseInt(createdBy),
        flag,
      };

      const response = await IUDAPI(data, "RoomTypeAPI/IUDRoomType");
      const result = response?.data?.Table?.[0]?.Result;

      if (flag === 3 && result === "D") {
        toast.success("Deleted successfully 🗑️");
        setTimeout(cancel, 3000);
      } else if (flag === 4 && result === "B") {
        toast.success("Inactivated successfully 🚫");
        setTimeout(cancel, 3000);
      } else if (flag === 5 && result === "UB") {
        toast.success("Activated successfully ✅");
        setTimeout(cancel, 3000);
      } else {
        toast.error("Operation failed 👎");
        setTimeout(cancel, 3000);
      }
    }
  };

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Room Types"
          header={RoomTypeHeader}
          records={bindRoomTypeData}
          handleEdit={handleEdit}
          handleAction={handleRoom}
          showAdd={showAdd}
          blockView={false}
        />
      )}
      {visibleAdd && (
        <>
          <div>
            <AddScreenTitle
              title="Room Types"
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
            />
          </div>
          <div className={mainTable.addShadowScreen}>
            <div className={mainTable.mainContentScreen}>
              <form className={mainTable.formForClientMaster}>
                <div className={mainTable.grid4}>
                  <InputText
                    title="Room Type"
                    inputType="text"
                    name="RoomType"
                    classStar="text-red-500"
                    controlFunc={(e) => {
                      setFormFields({
                        ...formFields,
                        roomType: e.target.value,
                      });
                    }}
                    controlFuncBlur={() => {
                      const value = formFields.roomType?.trim() || "";
                      const regex = /^[A-Za-z\s\-]{2,}$/;

                      let error = "";

                      if (!value) {
                        error = "Enter Room Type";
                      } else if (!regex.test(value)) {
                        error =
                          "Only letters, spaces, and hyphens (min 2 chars)";
                      } else if (
                        bindRoomTypeData.some(
                          (item) =>
                            item.RoomType?.trim().toLowerCase() ===
                              value.toLowerCase() &&
                            item.MstRoomTypeId !== formFields.mstRoomtypeId
                        )
                      ) {
                        error = "Room Type already exists.";
                      }

                      setFormFieldsError((prev) => ({
                        ...prev,
                        roomTypeError: error,
                      }));
                    }}
                    content={formFields.roomType}
                    placeholder="Room Type"
                    // tabIndex="1"
                    errorMessage={formFieldsError.roomTypeError}
                    maxLength={50}
                  />
                  <InputText
                    title="No. of Rooms"
                    inputType="text"
                    name="noofrooms"
                    classStar={"text-red-500"}
                    controlFunc={(e) => {
                      const value = e.target.value.trim();
                      const regex = /^\d*$/;
                      if (regex.test(value)) {
                        setFormFields({
                          ...formFields,
                          noofroom: e.target.value,
                        });
                      }
                    }}
                    controlFuncBlur={() => {
                      const value = (formFields.noofroom || "")
                        .toString()
                        .trim();
                      let error = "";
                      if (!value) {
                        error = "Enter No of Rooms";
                      }
                      setFormFieldsError({
                        ...formFieldsError,
                        noofroomError: error,
                      });
                    }}
                    content={formFields.noofroom}
                    placeholder="No. of Rooms"
                    // tabIndex="1"
                    errorMessage={formFieldsError.noofroomError}
                    maxLength={2}
                  />
                  <InputText
                    title="Size in Sq.ft"
                    inputType="text"
                    name="size"
                    classStar={"text-red-500"}
                    controlFunc={(e) => {
                      const value = e.target.value.trim();
                      const regex = /^\d*$/;
                      if (regex.test(value)) {
                        setFormFields({
                          ...formFields,
                          size: e.target.value,
                        });
                      }
                    }}
                    controlFuncBlur={() => {
                      const value = (formFields.size || "").toString().trim();
                      let error = "";
                      if (!value) {
                        error = "Enter size";
                      }
                      setFormFieldsError({
                        ...formFieldsError,
                        sizeError: error,
                      });
                    }}
                    content={formFields.size}
                    placeholder="Size"
                    // tabIndex="1"
                    errorMessage={formFieldsError.sizeError}
                    maxLength={4}
                  />

                  <InputText
                    title="Maximum Occupancy"
                    inputType="text"
                    name="maximumOccpancy"
                    classStar={"text-red-500"}
                    controlFunc={(e) => {
                      const value = e.target.value.trim();
                      const regex = /^\d*$/;
                      if (regex.test(value)) {
                        setFormFields({
                          ...formFields,
                          maximumOccpancy: e.target.value,
                        });
                      }
                    }}
                    controlFuncBlur={() => {
                      const value = (formFields.maximumOccpancy || "")
                        .toString()
                        .trim();
                      let error = "";
                      if (!value) {
                        error = "Enter no. of maximum Occpancy";
                      }
                      setFormFieldsError({
                        ...formFieldsError,
                        maximumOccpancyError: error,
                      });
                    }}
                    content={formFields.maximumOccpancy}
                    placeholder="Maximum Occpancy"
                    // tabIndex="1"
                    errorMessage={formFieldsError.maximumOccpancyError}
                    maxLength={2}
                  />
                </div>
                <FileUpload
                  title="Photo"
                  classStar="text-red-500"
                  apiCall="RoomTypeAPI/RoomTypeImageUpload"
                  modalName="RoomTypeImages"
                  name="showImage"
                  disabledBtn={updateScreenTitle}
                  showImage={formFields.photo}
                  showImageData={handleShowImage}
                  imageUploadedError={formFieldsError.photoError}
                  limitMassage="Image size limit: 2MB. Accepted Image types: jpg, png, jpeg."
                  MAX_FILE_SIZE_MB={2}
                  ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                />

                <TextArea
                  title="Description"
                  rows={3}
                  content={formFields.description}
                  name="discription"
                  controlFunc={(e) => {
                    setFormFields({
                      ...formFields,
                      description: e.target.value,
                    });
                  }}
                  placeholder="Description"
                  // tabIndex="1"
                  maxLength={500}
                />
              </form>
              <Buttons
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
                handleSubmit={handleSubmit}
                cancel={cancel}
                // disabledBtn={submitBtnDisabled ? true : false}
              />
            </div>
          </div>
        </>
      )}   {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleRoom}
      >
        <div>
          <PopUpScreenTitle
            title="Room Types"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <RoomTypeMasterPopup data={popupData} data1={popupDataDD} />
        </div>

        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          handleSubmit={handleSubmit}
          cancel={cancel}
        />
      </MainPopup>
    </MainLayout>
  );
};
export default RoomType;
